
<template>
  <v-container fluid>
    <div>
      <Header icon="sign-out-pink" routeTo="Logout" />

      <a v-if="$store.getters.user.role === 'a' || $store.getters.user.hospital.multiAccountSupport" href="/dashboard/nurses">
        <ListItem noTopBorder="true" icon="home-blue.svg">
          <span class="valign-middle">{{ $t("dash.menu.staff") }}</span>
        </ListItem>
      </a>
      <a v-else :href="'/dashboard/nurse/' + $store.getters.user.id + '/patients'">
        <ListItem noTopBorder="true" icon="home-blue.svg">
          <span class="valign-middle">{{ $t("dash.info.bedOverview") }}</span>
        </ListItem>
      </a>
      <a href="/dashboard/dictionary">
        <ListItem icon="book-blue.svg">
          <span class="valign-middle">{{ $t("dash.menu.dictionary") }}</span>
        </ListItem>
      </a>
      <a href="/dashboard/hospital" v-if="this.$store.getters.user.role === 'a'">
        <ListItem icon="question-mark-blue.svg">
          <span class="valign-middle">{{ $t("dash.menu.info") }}</span>
        </ListItem>
      </a>
      <a href="/settings/language?display=1">
        <ListItem icon="comment-blue.svg">
          <span class="valign-middle">{{
            $t("app.settings.general.display-language")
          }}</span>
        </ListItem>
      </a>
      <a href="/dashboard/statistics" v-if="this.$store.getters.user.role === 'a'">
        <ListItem icon="fa-chart-line" fontawesome="true">
          <span class="valign-middle">{{
              $t("app.settings.general.statistics")
            }}</span>
        </ListItem>
      </a>
      <a v-if="this.$store.getters.user.role === 'a'" @click.prevent="signInCuraeConsent">
        <ListItem icon="fa-regular fa-folder" fontawesome="true" last="true">
          <span class="valign-middle">{{
              $t("app.settings.general.curae-consent-login")
            }}</span>
        </ListItem>
      </a>
      <!-- <a href="/forgot/password">
        <ListItem icon="settings-blue.svg" last="true">
          <span class="valign-middle">{{ $t("dash.menu.password") }}</span>
        </ListItem>
      </a> -->
      <p>v.{{gitVersion}}</p>
    </div>
  </v-container>
</template>

<script>
import { curaeConsent } from "@/api";

export default {
  props: ['git-version'],
  name: "neoparent-dashboard-home",
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    async signInCuraeConsent() {
      this.$root.$emit('m2h-loader-show')
      const that = this
      await curaeConsent.ssoCuraeConsent()
        .then((res) => {
          if (res.data.success) {
            window.open(res.data.url, '_blank');
          }
        }).finally(() => {
          that.$root.$emit('mediligo-loader-hide');
        })
    }
  }
};
</script>

<style scoped lang="scss"></style>
